import {
  IconShieldExclamation,
  IconMessageCircle,
  IconBug,
  IconSend,
  IconMail,
  IconCirclePlus,
} from "@tabler/icons-react";
import styles from "./Support.module.css";

export default function SupportCards({ onOpenModal }) {
  return (
    <div>
      <div className={styles.sectionHead}>
        <span className={styles.sectionHeadTitle}>Get Support</span>
      </div>
      <div className={styles.cards}>
        <button
          className={`${styles.card} ${styles.cardReport}`}
          onClick={() => onOpenModal("report")}
        >
          <div className={`${styles.scIconWrap} ${styles.scIconRed}`}>
            <IconShieldExclamation size={24} />
          </div>
          <div className={styles.scTitle}>Report Behaviour</div>
          <p className={styles.scDesc}>
            Concerned about a user's conduct? Flag inappropriate behaviour so
            our trust &amp; safety team can review it.
          </p>
          <span
            className={`${styles.scCta} ${styles.scCtaRed}`}
            onClick={(e) => {
              e.stopPropagation();
              onOpenModal("report");
            }}
          >
            <IconSend size={14} /> Report Now
          </span>
        </button>

        <button
          className={`${styles.card} ${styles.cardContact}`}
          onClick={() => onOpenModal("contact")}
        >
          <div className={`${styles.scIconWrap} ${styles.scIconBlue}`}>
            <IconMessageCircle size={24} />
          </div>
          <div className={styles.scTitle}>Contact Us</div>
          <p className={styles.scDesc}>
            Have a question or general enquiry? Our support team is ready to
            help you with anything on the platform.
          </p>
          <span
            className={`${styles.scCta} ${styles.scCtaBlue}`}
            onClick={(e) => {
              e.stopPropagation();
              onOpenModal("contact");
            }}
          >
            <IconMail size={14} /> Get in Touch
          </span>
        </button>

        <button
          className={`${styles.card} ${styles.cardBug}`}
          onClick={() => onOpenModal("bug")}
        >
          <div className={`${styles.scIconWrap} ${styles.scIconAmber}`}>
            <IconBug size={24} />
          </div>
          <div className={styles.scTitle}>Log a Bug</div>
          <p className={styles.scDesc}>
            Found something broken or behaving unexpectedly? Help us improve by
            submitting a detailed bug report.
          </p>
          <span
            className={`${styles.scCta} ${styles.scCtaAmber}`}
            onClick={(e) => {
              e.stopPropagation();
              onOpenModal("bug");
            }}
          >
            <IconCirclePlus size={14} /> Log a Bug
          </span>
        </button>
      </div>
    </div>
  );
}
